<template>
  <div class="container text-center container_bg">
    <h2 class="pt-6">投保单</h2>
    <h4 class="pt-6" style="color: red">
      请下载当前投保单文件，所需信息系统已填好，空白部分无需填写，下载打印第一页后盖公章，上传扫描件至本系统(上传文件格式支持PDF、图片)。
    </h4>
    <Step :arr="arr" class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <pdf :url="pdfUrl"></pdf>
    </div>
    <el-button
      type="primary"
      style="margin-left: 10px"
      class="mt-3 mb-3"
      @click="goDownload"
    >
      下载 <i class="el-icon-download el-icon--right"></i
    ></el-button>
    <el-upload
      class="upload-demo inline-block"
      style="margin-left: 20px"
      :show-file-list="false"
      :multiple="false"
      :limit="1"
      ref="upload"
      action="/zcjf/base/file/upload"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :before-upload="beforeAvatarUpload"
      :data="actionData"
      accept =".png, .jpg, .jpeg, .pdf"
    >
      <el-button type="primary" class="mt-3 mb-3" :loading="loading"
        >{{ uploadTitle }}<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </el-upload>

    <el-button
      v-if="isShowPay"
      type="primary"
      style="margin-left: 20px"
      class="mt-3 mb-3"
      @click="goPay"
      >{{ payTitle }} </el-button
    >
  </div>
</template>
<script>
import Step from '../../components/CA/Step'
import pdf from '../../components/pdf/pdf'
import { uploadUndertaking } from '@/api/order'
import { download3 } from '@/shared/file'
import uploadE from '../../../src/common/upload/uoload.vue'
import { pay } from '@/shared/pay'
import { queryOrderDetail } from '@/api/order'
export default {
  name: 'insuranceLetterCmmmit.vue',
  data() {
    return {
      actionData: {
        module1: 'bfe',
        module2: 'bfe_guarantee_main',
      },
      fileList: [],
      pdfUrl: '',
      arr: [
        { icon: 1, span: '投保单确认', status: 'finish', time: '' },
        { icon: 2, span: '上传扫描件', status: 'active', time: '' },
        { icon: 3, span: '去支付', status: 'wait', time: '' },
      ],
      loading: false,
      query: {}, // fixed ie bug
      uploadTitle: '上传扫描件',
      fileId: null,
      paymentType: null,
      commitmentPdfSginId: null,
      guaranteeApplyStatus: null,
      isShowPay: false,
      payTitle: '已上传成功,去支付',
    }
  },

  components: {
    Step,
    pdf,
    UP: uploadE,
  },
  computed: {
    isUploadTransfer() {
      // 线下支付判断条件: 保险保函机构收费
      return this.paymentType === '1' 
    },
  },
  beforeMount() {
    this.query = this.$route.query
    this.pdfUrl = '/zcjf/base/file/download/' + this.$route.query.pdfID
  },
  created() {
    const { orderId } = this.$route.query
    if (orderId) {
      queryOrderDetail(orderId).then((res) => {
        this.paymentType = res.data.paymentType
        this.commitmentPdfSginId = res.data.commitmentPdfSginId
        this.guaranteeApplyStatus = res.data.guaranteeApplyStatus
        this.applyType = res.data.applyType
        this.basicPay = res.data.basicPay
          if(this.isUploadTransfer){
            this.arr[2].span = '上传电汇底单'
            this.payTitle = '已上传成功,去上传电汇底单'
          }
        if (this.commitmentPdfSginId && this.guaranteeApplyStatus === '1000') {
          this.fileId = this.commitmentPdfSginId
          this.$refs.upload.clearFiles()
          this.uploadTitle = '重新上传'
          this.arr[1].status = 'finish'
          this.arr[2].status = 'active'
          this.isShowPay = true
        }else if( this.guaranteeApplyStatus == '4000'){
          this.arr[1].span = '重新上传扫描件'
        }else if(this.commitmentPdfSginId && this.guaranteeApplyStatus >= 2000){
          return this.$router.push({
          path: '/orderDetail',
          query: {
            order: orderId,
          },
        })
        }
      })
    }
  },
  methods: {
    goDownload() {
      const { orderId } = this.$route.query
      download3(this.$route.query.pdfID,orderId+'_'+'投保单.pdf')
    },
    goPay() {
      if (!this.fileId) {
        this.$message.error('请先上传扫描件')
        return
      }
      const { orderId } = this.$route.query
      if (this.paymentType != undefined) {
        if (this.paymentType === '1') {
          //线下支付
          // 线下支付
          this.$router.push({
            path: '/wire-transfer',
            query: {
              order: orderId,
            },
          })
        } else {
          // 线上支付
          pay.call(this, orderId)
        }
      } else {
        pay.call(this, orderId)
      }
    },
    uploadSuccess(res) {
      this.form.tenderFileId = res.url
      this.$refs.form.validateField('tenderFileId')
    },
    handleExceed() {
      this.$message.warning(
        '上传超过限制，只能上传1个文件，请删除当前文件后操作'
      )
    },
    handlePreview(file) {
      console.log(file)
    },
    //文件移除钩子，用于清理fileId
    handleRemove(file, fileList) {
      this.$emit('fileIdCb', { url: '' })
    },
    // 文件上传成功钩子函数
    handleUploadSuccess(res, file) {
      const { orderId } = this.$route.query
      uploadUndertaking({
        fileId: res.url,
        orderId: orderId,
      }).then((v) => {
        if (v.code === 200) {
          if (this.guaranteeApplyStatus === '4000') {
            this.$message.success('投保单上传成功,订单待出函')
            return this.$router.push({
              path: '/orderDetail',
              query: {
                order: orderId,
              },
            })
          }else{
            this.$message.success('投保单上传成功！')
          }
            this.$refs.upload.clearFiles()
            this.uploadTitle = '重新上传'
            this.arr[1].status = 'finish'
            this.arr[2].status = 'active'
            this.fileId = res.url
            this.isShowPay = true
        }
        this.loading = false
        this.$refs.upload.clearFiles()
      }).catch(() => {
        this.loading = false
        this.$refs.upload.clearFiles()             
      })

    
    },
    handleUploadError(err, file, fileList) {
      this.$message.success('上传失败')
      this.loading = false
    },

    // 文件上传拦截
    beforeAvatarUpload(file) {
      this.loading = true
      if (file.size > 1073741824) {
        this.$message.error(
          '上传文件大小超过限制！请上传小于' +
            this.maxSize / 1024 / 1024 +
            'MB大小的文件'
        )
        return false
      }
      let fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      let filetypes = ['png', 'jpg', 'jpeg', 'pdf']
      if (filetypes.indexOf(fileType) === -1) {
        this.$message.error('上传文件格式不正确')
        return false
      }
    },
  },
}
</script>
<style type="text/css">
.inline-block {
  display: inline-block;
}
</style>